import { render } from "./ProductOptions.vue?vue&type=template&id=1c3e1860&scoped=true"
import script from "./ProductOptions.vue?vue&type=script&lang=js"
export * from "./ProductOptions.vue?vue&type=script&lang=js"

import "./ProductOptions.vue?vue&type=style&index=0&id=1c3e1860&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3e1860"]])

export default __exports__